// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './AchievementNotification.css';

/**
 * Achievement Notification Component
 * 
 * Shows a toast notification when an achievement is unlocked
 */
const AchievementNotification = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleAchievement = (event) => {
      const { achievement } = event.detail;
      
      setNotification(achievement);
      setIsVisible(true);

      // Auto-hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => setNotification(null), 300); // Wait for fade out
      }, 5000);
    };

    window.addEventListener('ACHIEVEMENT_UNLOCKED', handleAchievement);
    return () => window.removeEventListener('ACHIEVEMENT_UNLOCKED', handleAchievement);
  }, []);

  if (!notification) return null;

  return createPortal(
    <div className={`achievement-notification ${isVisible ? 'visible' : ''}`}>
      <div className="achievement-notification-content">
        <div className="achievement-notification-header">
          <span className="achievement-notification-trophy">🏆</span>
          <span className="achievement-notification-title">Achievement Unlocked!</span>
        </div>
        <div className="achievement-notification-body">
          <span className="achievement-notification-icon">{notification.icon}</span>
          <div className="achievement-notification-details">
            <div className="achievement-notification-name">{notification.name}</div>
            <div className="achievement-notification-description">{notification.description}</div>
            <div className="achievement-notification-points">+{notification.points} points</div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AchievementNotification;
